<template>
  <div class="content-wrapper">
  	<div class="wrapper-padding-bottom">
      <div v-if="!isTouch" class="span-full bgblue" data-type="layout">
        <div id="sea" class="full-inner">
          <div v-for="(fish, index) in fishSchoolData" class="fish" :class="fish.color" v-bind:style="{left: fish.x, top: fish.y}"></div>
        </div>
        <a href="#" data-index="0" class="read-more">
          <span class="arrow-down"></span>
        </a>
      </div>
      <div v-if="isTouch" class="span-full bgblue">
        <div id="sea-responsive" class="full-inner">
          <img v-bind:src="'/static/images/solutions-responsive-hero.png'" alt="">
        </div>
        <transition name="error-fade">
          <div v-show="showArrow" class="read-more">
            <icon name="customangledown" scale="2.5"></icon>
          </div>
        </transition>
        <a href="#" data-index="0" class="read-more">
          <span class="arrow-down"></span>
        </a>
      </div>
      <solutions-promises></solutions-promises>
      <solutions-tips></solutions-tips>
    </div>
  	<footer-app></footer-app>
  </div>
</template>

<script>
import FooterApp from './Footer'
import SolutionsPromises from './Solutions-promises'
import SolutionsTips from './Solutions-tips'
import misc from '../js/scripts.js'

export default {
  name: 'Solutions',
  components: {
  	FooterApp,
    SolutionsPromises,
    SolutionsTips
  },
  data() {
    return {
      title: {
        en: 'The Solution Against Single-use Plastic',
        es: 'La Solución Contra el Plástico Desechable'
      },
      description: {
        en: 'There’s only one possible solution against plastic pollution. Saying NO to single-use plastic! Learn how here.',
        es: 'Solo existe una solución contra la polución plástica: dejar de consumir el plástico desechable. Aquí te enseñamos a cómo conseguirlo.'
      },
      isTouch: misc.isTouch(),
      showArrow: true,
      fishSchool: [],
      fishSchoolData: [
        {color: 'red',      x: '10%', y: '20%'},
        {color: 'blue',     x: '10%', y: '50%'},
        {color: 'yellow',   x: '7%', y: '86%'},
        {color: 'green',    x: '22%', y: '55%'},
        {color: 'blue',     x: '25%', y: '90%'},
        {color: 'blue',     x: '32%', y: '16%'},
        {color: 'orange',   x: '33%', y: '44%'},
        {color: 'green',    x: '35%', y: '65%'},
        {color: 'red',      x: '48%', y: '8%'},
        {color: 'red',      x: '50%', y: '80%'},
        {color: 'green',    x: '52%', y: '20%'},
        {color: 'orange',   x: '57%', y: '24%'},
        {color: 'yellow',   x: '60%', y: '60%'},
        {color: 'orange',   x: '56%', y: '92%'},
        {color: 'blue',     x: '72%', y: '38%'},
        {color: 'yellow',   x: '80%', y: '10%'},
        {color: 'orange',   x: '76%', y: '64%'},
        {color: 'green',    x: '85%', y: '40%'},
        {color: 'blue',     x: '85%', y: '50%'},
        {color: 'blue',     x: '81%', y: '80%'},
        {color: 'yellow',   x: '90%', y: '20%'}
      ],
    }
  },
  head: {
    title() {
      return {
        inner: this.title[localStorage.getItem('language')]
      }
    },
    meta() {
      return [
        { name: 'description', content: 'Descripcion de Soluciones' },
        { name: 'twitter:title', content: this.title[localStorage.getItem('language')] },
        { name: 'twitter:descripcion', content: this.description[localStorage.getItem('language')] },
      ]
    },
    link() {
      return [
        { rel: 'canonical', href: window.location.href },
      ]
    }
  },
  methods: {
    updateFishScholl(x, y) {
      var offsetX = 50;
      var offsetY = 34;
      var i = 0;
      for(i = 0; i < this.fishSchool.length; i++) {
        var fish = this.fishSchool[i];
        var fishX = fish.offsetLeft + offsetX;
        var fishY = fish.offsetTop + offsetY;

        var deltaX = x - fishX;
        var deltaY = y - fishY;

        var deg = Math.atan2(deltaY, deltaX) * 180 / Math.PI;

        fish.style.webkitTransform = 'rotate(' + deg + 'deg)'; 
        fish.style.mozTransform    = 'rotate(' + deg + 'deg)'; 
        fish.style.msTransform     = 'rotate(' + deg + 'deg)'; 
        fish.style.oTransform      = 'rotate(' + deg + 'deg)'; 
        fish.style.transform       = 'rotate(' + deg + 'deg)'; 
      }
    },
    scrollContent(){
      const offset = 60
      document.querySelectorAll('.wrapper-padding-bottom .span-full').forEach( (item) => {
        if( item.getBoundingClientRect().top < offset && item.getBoundingClientRect().bottom > offset )
          if( item.dataset.header )
            document.querySelector('.header-nav').dataset.color = item.dataset.header
          else 
            document.querySelector('.header-nav').dataset.color = 'white'
      })
    },
    handleArrow(){
      if( document.body.scrollTop > 200 ){
        this.showArrow = false
      }
      if( document.body.scrollTop === 0 )
        this.showArrow = true
    },
    doArrow(){
      misc.scrollTo2('#promises', 600);
    },
    loadContent(){
      this.title[localStorage.getItem('language')] = this.title[localStorage.getItem('language')]
      this.$emit('updateHead')
    }
  },
  watch: {
    '$route': 'loadContent'
  },
  mounted() {
    misc.addArrows()
    window.addEventListener('scroll', this.scrollContent )
    window.addEventListener('scroll', this.handleArrow )
    
    if( this.isTouch ) return false;

    var sea = document.getElementById('sea');
    this.fishSchool = document.getElementsByClassName('fish');
    var scope = this;

    sea.onmousemove = function(e) {
      var x = e.pageX;
      var y = e.pageY;
      scope .updateFishScholl(x, y);
    }

  },
  destroyed(){
    window.removeEventListener('scroll', this.scrollContent )
    window.removeEventListener('scroll', this.handleArrow )
  }
}
</script>
<style lang="stylus">
#sea
  overflow hidden
  width 100% 
  height 100%
  cursor: url('/static/images/solutions-bottle.png'), auto; 
  
  .fish
    width 100px
    height 68px
    display block
    position absolute
    background-repeat no-repeat

    &.blue
      background-image url('/static/images/fish-blue.svg')
    &.red
      background-image url('/static/images/fish-red.svg')  
    &.yellow
      background-image url('/static/images/fish-yellow.svg')
    &.green
      background-image url('/static/images/fish-green.svg')
    &.orange
      background-image url('/static/images/fish-orange.svg')
#sea-responsive
  img
    display: block
    max-width 100%
</style>


// WEBPACK FOOTER //
// Solutions.vue?37fe052e